import classNames from 'classnames';
import React, { useCallback } from 'react';

import styles from './switch.module.css';

interface SwitchProps<T> {
  value: T;
  on: boolean;
  onClick: (value: T, on: boolean) => void;
  disabled?: boolean;
  stopPropagation?: boolean;
  paused?: boolean;
}

const Switch = <T,>({
  value,
  on,
  onClick,
  disabled = false,
  stopPropagation = false,
  paused = false,
}: SwitchProps<T>) => {
  const memoizedClick = useCallback(
    (e?: React.MouseEvent<HTMLButtonElement>) => {
      if (disabled) return;
      if (stopPropagation) {
        e?.stopPropagation();
      }
      onClick(value, !on);
    },
    [disabled, on, onClick, stopPropagation, value]
  );

  return (
    <button
      onClick={memoizedClick}
      className={classNames('clear-button', styles['switch'], {
        [styles['on']]: on,
        [styles['isDisabled']]: disabled,
        [styles['paused']]: paused,
      })}
      disabled={paused || disabled}
    >
      <div className={styles['gutter']}>
        <div className={styles['thumb']} />
      </div>
    </button>
  );
};

export default Switch;
